//
import CheckRoutes from './SlCheck'
import CustomerRoutes from './SlCustomer'
import CustomerAccountReceivableRoutes from './SlCustomerAccountReceivable'
//import GroundSellerRoutes from './SlGroundSeller'
import GroundSellerSaleRoutes from './SlGroundSellerSale'
import SaleDebitNoteRoutes from './SlSaleDebitNote'
import TaxDocumentRoutes from './SlTaxDocument'
import CreditNote from './SlSaleCreditNote'
import GTransbankDeposit from './GTransbankDeposit'
import { CheckPendingRoutes } from './SlCheck'
import SlSellerSaleCommission from './SlSellerSaleCommission'

//
export default [
  CheckRoutes,
  CheckPendingRoutes,
  CustomerRoutes,
  CustomerAccountReceivableRoutes,
  //GroundSellerRoutes,
  GroundSellerSaleRoutes,
  SaleDebitNoteRoutes,
  TaxDocumentRoutes,
  CreditNote,
  GTransbankDeposit,
  SlSellerSaleCommission,
]
